@let request = requestInput();
<fieldset>
  <legend class="keyLabel">Performance Inputs</legend>
  <div class="content">
    <div class="inputRow">
      <label class="inputLabel">Input Type:</label>
      <select class="inputSelection" [(ngModel)]="metricInput" (change)="metricInputChanged()">
        <option [value]="'False'">Imperial</option>
        <option [value]="'True'">Metric</option>
      </select>
      @if (!isAirHandler()) {
        <span>
          <label class="inputLabel">Fan Speed:</label>
          <select class="inputSelection fanSpeedSelection" [(ngModel)]="request.FanSpeed" (change)="inputChanged()">
            <option [value]="'H'">High</option>
            <option [value]="'M'">Medium</option>
            <option [value]="'L'">Low</option>
            <option [value]="'C'">ECM Design Airflow</option>
          </select>
        </span>
      }
      <label class="inputLabel">Airflow:</label>
      <input type="number" class="inputValue" [(ngModel)]="request.Airflow" (change)="inputChanged()"/>
      <label class="unitLabel">{{ getAirflowUnits() }}</label>
      <label class="inputLabel">ESP:</label>
      <input type="number" class="inputValue" [(ngModel)]="request.ExternalStaticPressure" (change)="inputChanged()"/>
      <label class="unitLabel">{{ getEspUnits() }}</label>
      <label class="inputLabel">Altitude:</label>
      <input type="number" class="inputValue" [(ngModel)]="request.Altitude" (change)="inputChanged()"/>
      <label class="unitLabel">{{ getLengthUnits() }}</label>
    </div>
    <div class="inputRow">
      @if (request.PrimaryCoilRequest) {
        <div class="coilRatingContainer">
          <app-schedule-line-performance-coil-input [coilRequest]="request.PrimaryCoilRequest"
            (metricInputUpdated)="primaryMetricInputUpdated()"
            (inputChanged)="inputChanged()" [fieldLabel]="'Primary Coil'"
            [metricInput]="request.IsMetricInput">
          </app-schedule-line-performance-coil-input>
        </div>
      }
      @if (request.SecondaryCoilRequest) {
        <div class="coilRatingContainer">
          <app-schedule-line-performance-coil-input [coilRequest]="request.SecondaryCoilRequest"
            (metricInputUpdated)="secondaryMetricInputUpdated()"
            (inputChanged)="inputChanged()" [fieldLabel]="'Secondary Coil'"
            [metricInput]="request.IsMetricInput">
          </app-schedule-line-performance-coil-input>
        </div>
      }
      @if (request.ElectricHeatRequest) {
        <div class="coilRatingContainer">
          <app-schedule-line-performance-coil-input [coilRequest]="request.ElectricHeatRequest"
            (metricInputUpdated)="eHeatMetricInputUpdated()"
            (inputChanged)="inputChanged()" [fieldLabel]="'Electric Heat'"
            [metricInput]="request.IsMetricInput">
          </app-schedule-line-performance-coil-input>
        </div>
      }
    </div>
  </div>
</fieldset>
